import isEqual from 'lodash/isEqual';
import React from 'react';
import {Dimensions, Image, View, StyleSheet} from 'react-native';
import {Button, Input, Text} from 'react-native-elements';
import {toast} from 'react-toastify';
import {getOTP} from '../../network/Network';
import MainSiteHeader from '../../components/MainSiteHeader';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export default class ForgotPasswordScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileNum: '',
      username: '',
      isMobileNoValid: false,
      isUsernameValid: false,
      isFormTouched: false,
      mobileNoErrMsg: 'Mobile Number is required.',
      usernameErrMsg: 'Username is required.',
      isLoading: false,
    };
  }

  componentDidMount() {
    //
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!isEqual(nextProps, this.props) || !isEqual(nextState, this.state)) {
      return true;
    } else {
      return false;
    }
  }

  onPressOfVerifyByOtp = () => {
    this.setState({
      isFormTouched: true
    });
    if(!this.state.isMobileNoValid || !this.state.isUsernameValid){
      return;
    }
    this.setState({
      isLoading: true,
    });
    getOTP(this.state.mobileNum, this.state.username)
      .then((data) => {
        if (
          data.success === true &&
          data.status === 201 &&
          data.data.success === true
        ) {
          this.props.navigation.replace('ResetPassword', {
            mobileNum: this.state.mobileNum,
            username: this.state.username
          });
        } else {
          toast(data.data.message);
        }
        this.setState({
          isLoading: false,
        });
      })
      .catch((r) => {
        console.log(r);
        toast("Error, try again.");
        this.setState({
          isLoading: false,
        });
      });
  };

  onMobileNumberChangeText = (input) => {
    this.setState({
      mobileNum: input,
    });
    if(input.length > 0){
      this.setState({
        isMobileNoValid: true
      });
    } else{
      this.setState({
        isMobileNoValid: false,
        isFormTouched: true
      });
    }
  };

  onUsernameChangeText = (input) => {
    this.setState({
      username: input,
    });
    if(input.length > 0){
      this.setState({
        isUsernameValid: true
      });
    } else{
      this.setState({
        isUsernameValid: false,
        isFormTouched: true
      });
    }
  };

  render() {
    return (
      <View style={styles.viewStyle}>
        <MainSiteHeader navigation={this.props.navigation}/>
          <View style={styles.boxContainer}>
            <View style={{width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 3, backgroundColor: 'black', padding: 16, alignSelf: 'center'}}>
              <Image
                source={process.env.PUBLIC_URL + '/assets/ulka-1.png'}
                style={styles.imageStyle}
              />
              <Input
                placeholder={'Mobile No.'}
                placeholderTextColor="grey"
                inputStyle={styles.inputStyle}
                onChangeText={this.onMobileNumberChangeText}
              />
              {this.state.isFormTouched && !this.state.isMobileNoValid && (
                <Text style={{ color: 'red', marginLeft: 8, marginBottom: 8 }}>{this.state.mobileNoErrMsg}</Text>
              )}
              <Input
                placeholder={'User ID'}
                inputStyle={styles.inputStyle}
                placeholderTextColor="grey"
                onChangeText={this.onUsernameChangeText}
                containerStyle={{ marginTop: 8 }}
              />
              {this.state.isFormTouched && !this.state.isUsernameValid && (
                <Text style={{ color: 'red', marginLeft: 8, marginBottom: 8 }}>{this.state.usernameErrMsg}</Text>
              )}
              <Button
                loading={this.state.isLoading}
                onPress={this.onPressOfVerifyByOtp}
                raised
                containerStyle={styles.buttonContainerStyle}
                buttonStyle={styles.buttonStyle}
                title={'Get OTP'}
              />
            </View>
          </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT,
    width: WIDTH
  },
  boxContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlignVertical: 'center',
    alignContent: 'center',
    height: HEIGHT-72,
  },
  imageStyle: {
    height: 100, 
    width: 200, 
    alignSelf: 'center', 
    marginBottom: 24
  },
  inputStyle: {
    color: 'white', 
    marginBottom: 8
  },
  buttonStyle: {
    backgroundColor: 'red',
    height: 50,
  },
  buttonContainerStyle: {
    marginTop: 16
  },
  moreViewStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  textStyle: {
    color: 'white', 
    fontSize: 16
  },
  contextTextStyle: {
    color: 'white',
    fontWeight: 600,
    fontFamily: 'Source Sans Pro',
    fontSize: 18,
    margin: 20,
    textAlign: 'center'
  },
});
